// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResponseWrapper } from '@library/common';
import { CacheService } from '@library/core';
import { BehaviorSubject, Observable, Subject, catchError, map, pipe, takeUntil, tap } from 'rxjs';
// import { ShipmentFactory } from '@library/common';
import { RecurrenceTypes, ScheduleReport, scheduleGroup } from './schedule-report';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
// import { ScheduleReport } from 'dist/library/modules/reports/schedule-report/schedule-report';


@Injectable({
   providedIn: 'root'
})
export class ScheduleReportService {

   get schedule() {
      return this.scheduleForm?.getRawValue();
   }
   set schedule(shipment: any) {
      this.scheduleForm = scheduleGroup(shipment);
   }

   private _scheduleForm: FormGroup;

   url = `reports/schedule`;
   contactsUrl = `ab/contacts`;

   refresh$: Subject<void> = new Subject();
   destroy$: Subject<boolean> = new Subject();
   reset$: Subject<void> = new Subject();

   recTypeSelected$: BehaviorSubject<any> = new BehaviorSubject('');
   reportName$: BehaviorSubject<string> = new BehaviorSubject('');
   scheduleForm$: BehaviorSubject<FormGroup> = new BehaviorSubject(null);

   get scheduleForm() { return this._scheduleForm; }
   set scheduleForm(group: FormGroup) {
      this._scheduleForm = group || scheduleGroup();

      // let val = this.convertWeekFrequency(this._scheduleForm.get('frequency_week').value);
      // this.scheduleForm.get('frequency_week').setValue(val);
      // this.frequency_week = val;

      // this.frequency_month = this._scheduleForm.get('frequency_month').value.map(Number);

      this.scheduleForm$.next(this._scheduleForm);
   }

   set types(value: any) { this.scheduleForm && this.scheduleForm.get('recurrence_period').setValue(value); }
   get types(): RecurrenceTypes { return this.scheduleForm && this.scheduleForm.get('recurrence_period').value; }

   // set days(value: DaysList) { this.scheduleForm && this.scheduleForm.get('frequency_week').setValue(value); }
   // get days(): DaysList { return this.scheduleForm && this.scheduleForm.get('frequency_week').value; }

   set frequency_month(value: any) { this.scheduleForm && this.scheduleForm.get('frequency_month').setValue(value); }
   get frequency_month(): any { return this.scheduleForm && this.scheduleForm.get('frequency_month').value; }

   set frequency_week(value: any) { this.scheduleForm && this.scheduleForm.get('frequency_week').setValue(value); }
   get frequency_week(): any { return this.scheduleForm && this.scheduleForm.get('frequency_week').value; }

   set no_end_date(value: boolean) { this.scheduleForm.get('no_end_date').setValue(value); }
   get no_end_date(): boolean { return this.scheduleForm && this.scheduleForm.get('no_end_date').value; }

   set schedule_name(value: any) { this.scheduleForm && this.scheduleForm.get('schedule_name').setValue(value); }
   get schedule_name(): any { return this.scheduleForm && this.scheduleForm.get('schedule_name').value; }

   set schedule_description(value: any) { this.scheduleForm && this.scheduleForm.get('schedule_description').setValue(value); }
   get schedule_description(): any { return this.scheduleForm && this.scheduleForm.get('schedule_description').value; }

   set startTime(value: string) { this.scheduleForm.get('startTime').setValue(value); }
   get startTime(): string { return this.scheduleForm && this.scheduleForm.get('startTime').value; }

   set startDate(value: string) { this.scheduleForm.get('startDate').setValue(value); }
   get startDate(): string { return this.scheduleForm && this.scheduleForm.get('startDate').value; }

   set endDate(value: string) { this.scheduleForm.get('endDate').setValue(value); }
   get endDate(): string { return this.scheduleForm && this.scheduleForm.get('endDate').value; }

   constructor(
      private snackbar: MatSnackBar,
      private cache: CacheService,
      private http: HttpClient,
      // private environmentService: EnvironmentService
   ) { }

   scheduleReport(report:any): Observable<any> {

      return this.http.post<ResponseWrapper<any>>( this.url, report, { params: { useLambda: true } }).pipe(
         map(rw => rw.response.collection),
         tap(_ => this.snackbar.open('Saved!', null, { duration: 3000, verticalPosition: 'bottom' })),
         catchError( e => { throw new Error( e ); })
      );

   }

   load(id: any, headers: any = null) {
      return this.cache.request<ResponseWrapper<ScheduleReport>, ScheduleReport[]>({
         url: `${this.url}/${id}`,
         refresher: this.refresh$, 
         pipe: pipe(
            map(rw => rw.response.collection),
            takeUntil(this.destroy$)
         ),
         headers,
         useLambda: true
      });
   }

   account( opts: { portal: string, id: string } | Params, headers: any = null ) {
      return this.load(opts.id,headers);
   }

   loadRecipients(): Observable<any> {
      return this.cache.request<ResponseWrapper<any>, any[]>({
         url: this.contactsUrl,
         refresher: this.refresh$,
         useLambda: true,
         pipe: pipe(
            map(rw => rw.response.collection),
            map(ab => ab.sort((a, b) => a.name.toLowerCase().charCodeAt(0) - b.name.toLowerCase().charCodeAt(0))),
            takeUntil(this.destroy$)
         ),
      });
   }

   mockData() {
      return {
         "messages": [],
         "type": "generic",
         "response": {
            "collection": [
               // {
               //    "id": "",
               //    "recurrence_period": "weekly",
               //    "startTime": "04:00",
               //    "startDate": "2024-05-25",
               //    "endDate": "2024-05-30",
               //    "no_end_date": false,
               //    "everyday": false,
               //    "frequency_month": [1, 4],
               //    "recipients": [
               //       {
               //          "recipient_name": "five",
               //          "recipient_email": "five@seven.com"
               //       },
               //       {
               //          "recipient_name": "MAIN",
               //          "recipient_email": "ssorgi.ph@radiantdelivers.com"
               //       }
               //       // {
               //       //    "recipient_name": "Scott Sorgi",
               //       //    "recipient_email": "ssorgi.ph@radiantdelivers.com"
               //       // }
               //    ],
               //    "frequency_week": [1, 3, 4, 5, 6, 2],
               //    "timezone": "EST",
               //    "schedule_name": "sample name11111",
               //    "schedule_description": "this is a sample description",
               //    "active": true,
               // }
            ]
            // "collection": [
            //    {
            //       "id": null,
            //       "recurrence_period": null,
            //       "startTime": '',
            //       "startDate": '',
            //       "endDate": null,
            //       "frequency": null,
            //       "no_end_date": false,
            //       "recipients": [],
            //       "frequency_week": [],
            //       "timezone": null,
            //       "schedule_name": null,
            //       "schedule_description": "",
            //       "active": true,
            //    }
            // ]
         }
      }
   }

   reset() {
      this.cache.clearSet(this.url);
      this.refresh$.next();
      this.reset$.next();
      this._scheduleForm = null;
      this.scheduleForm$.next(null);
      this.recTypeSelected$.next(null);
      this.reportName$.next(null);
   }

   convertWeekFrequency(days) {
      const numberToDay = {
         1: "mon",
         2: "tue",
         3: "wed",
         4: "thu",
         5: "fri",
         6: "sat",
         0: "sun"
      };
      return days.map(day => numberToDay[day]);
   }

}
